export const SHOW_COPY_LINKS = true;
export const SHOW_TEXT_BOX_COPY_BUTTON = false;
